import { api } from './_api-client';

export enum FolderType {
  Trash,
  Archive,
  Custom,
}

export interface Folder {
  id: FolderId;
  name: string;
  type: FolderType;
  userId: number;
}

export interface FolderQueryParams {
  folderId?: FolderId;
  allActive?: boolean;
}

export const setProjectFolder = (projectId: ProjectId, folderId: FolderId) => {
  return api.patch(`/Folder/SetProjectFolder?projectId=${projectId}&folderId=${folderId}`);
};

export const setMediaFileFolder = (fileId: FileId, folderId: FolderId) => {
  return api.patch(`/Folder/SetMediaFileFolder?mediaFileId=${fileId}&folderId=${folderId}`);
};

export const setStoryFolder = (storyId: StoryId, folderId: FolderId) => {
  return api.patch(`/Folder/SetStoryFolder?storyId=${storyId}&folderId=${folderId}`);
};

export const setFinalCutFolder = (finalCutId: FinalcutId, folderId: FolderId) => {
  return api.patch(`/Folder/SetFinalCutFolder?finalCutId=${finalCutId}&folderId=${folderId}`);
};

export const unsubscribeProjectFolder = (projectId: ProjectId) => {
  return api.delete(`/Folder/UnsubscribeProjectFolder?projectId=${projectId}`);
};

export const unsubscribeMediaFileFolder = (fileId: FileId) => {
  return api.delete(`/Folder/UnsubscribeMediaFileFolder?mediaFileId=${fileId}`);
};

export const unsubscribeStoryFolder = (storyId: StoryId) => {
  return api.delete(`/Folder/UnsubscribeStoryFolder?storyId=${storyId}`);
};

export const unsubscribeFinalCutFolder = (finalCutId: FinalcutId) => {
  return api.delete(`/Folder/UnsubscribeFinalCutFolder?finalCutId=${finalCutId}`);
};

export const createFolder = (name: string) => {
  return api.post(`/Folder/CreateFolder?name=${name}`);
};

export const updateFolderName = (folderId: FolderId, folderName: string) => {
  return api.patch('/Folder/UpdateFolder', { folderId, folderName });
};

export const deleteFolder = (folderId: FolderId) => {
  return api.delete(`/Folder/deleteFolder?folderId=${folderId}`);
};
